<!------------------------------------------------------------------------------
  Copyright (c) 2019. keni

  This file timerCountdown.vue is part of event_pass_client.dev.
  Unauthorized copying of this file, via any medium is strictly prohibited.
  Proprietary and confidential
  timerCountdown.vue can not be copied and/or distributed
  without the express permission of keni
  ----------------------------------------------------------------------------->
<template>
    <div class="bg-info z-index-2 text-center timer-countdown" v-if="newBasketTime>0">
        <div class="d-flex justify-content-between align-content-center">
            <slot class="timer-countdown--slot"></slot>
            <div>
                <small class="code timer-countdown--time" v-if="show_timer_result">
                    <span class="timer-countdown--digit">{{(minutes[0] == '0'? ' ' : minutes[0]) }}</span><span class="timer-countdown--digit">{{ minutes[1] }}</span>
                    <span id="middle">:</span>
                    <span class="timer-countdown--digit">{{seconds[0]}}</span><span class="timer-countdown--digit">{{ seconds[1] }}</span>
                </small>
            </div>
        </div>
    </div>
</template>

<script>
    export default {

        name: "timerCountdown",
        props: {
            newBasketTime: {
                type: Number,
                default: 0
            },
            show_timer_result:{
                type:Boolean,
                default:true
            }
        },
        destroyed() {
            if ( this.timer ) {
                clearInterval(this.timer);
                this.timer = null;
            }

        },
        data() {
            return {
                timer: null,
                totalTime: parseInt(this.newBasketTime),
            }
        },
        methods: {
            padTime: function(time) {
                let pad = (time < 10 ? '0' : '') + time;
                return pad.split('');
            },
            countdown: function( newValue ) {

                newValue = parseInt(newValue);
                let self = this;

                if ( newValue <= 0 ) {
                    return;
                }

                self.totalTime = newValue;

                if ( self.timer ) {
                    clearInterval(self.timer);
                    self.timer = null;
                }

                self.timer = setInterval(() => {

//                    sessionStorage.setItem('ckhBskStatus', self.totalTime);

                    //
                    // local storage of -1 forces end of timer, it goes to -1 on eg, clearing the basket elsewhere
                    if ( window.localStorage.ckhBskStatus == -1 ) {
                        clearInterval(self.timer);
                        self.timer = null;
                        self.totalTime = 0;
                    }
                    window.localStorage.ckhBskStatus = parseInt(self.totalTime);

                    this.$parent.basketTimeLeft = self.totalTime;

                    if (self.totalTime >= 1) {
                        self.totalTime--;
                    } else {
                        self.totalTime = 0;

                        clearInterval(self.timer);
                        self.timer = null;
                        self.$emit('TimeExpired');
                    }

                }, 1000)
            }
        },
        computed: {
            minutes: function() {
                let min = this.padTime(Math.floor(this.totalTime / 60));
                return min;
            },
            seconds: function() {
                let min = parseInt(this.minutes[0] + this.minutes[1]);
                return this.padTime(this.totalTime - (min * 60));
            }
        },
        watch: {
            newBasketTime: {
                immediate: true,
                handler(newValue) {
                    this.totalTime = newValue;
                    this.countdown(newValue);
                }
            }
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/modals/timerCountdown.vue